module.exports = __webpack_public_path__ + "img/VIva_Victory_Ledge_Logo.a390520c.png";